import React from "react";
import "./AnimatedBackground.css";

const AnimatedBackground = () => {
  const waveOffsets = [0, 1, 2, 3, 4, 5];

  const buildWavePath = (baseY, amplitude) => {
    const startX = -400;
    const segmentWidth = 520;
    const segments = 7;

    let path = `M ${startX} ${baseY}`;
    let currentX = startX;
    let currentDirection = 1;

    const firstCtrl1X = currentX + segmentWidth / 3;
    const firstCtrl1Y = baseY + amplitude * currentDirection;
    const firstCtrl2X = currentX + (2 * segmentWidth) / 3;
    const firstCtrl2Y = baseY - amplitude * currentDirection;
    currentX += segmentWidth;
    path += ` C ${firstCtrl1X} ${firstCtrl1Y}, ${firstCtrl2X} ${firstCtrl2Y}, ${currentX} ${baseY}`;

    for (let i = 1; i < segments; i++) {
      currentDirection *= -1;
      const controlX = currentX + segmentWidth / 2;
      const controlY = baseY + amplitude * currentDirection;
      currentX += segmentWidth;
      path += ` S ${controlX} ${controlY}, ${currentX} ${baseY}`;
    }

    return path;
  };

  return (
    <div className="animated-background">
      <div className="background-bubbles">
        {[...Array(5)].map((_, idx) => (
          <span key={idx} className={`bubble bubble-${idx + 1}`} />
        ))}
      </div>
      <svg className="wave-lines" viewBox="0 0 3200 900" preserveAspectRatio="none">
        <defs>
          <linearGradient id="waveGradient" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="rgba(255, 255, 255, 0.6)" />
            <stop offset="50%" stopColor="rgba(255, 255, 255, 0.32)" />
            <stop offset="100%" stopColor="rgba(255, 255, 255, 0.16)" />
          </linearGradient>
        </defs>
        {waveOffsets.map((offset, idx) => {
          const baseY = 550 - offset * 90;
          const amplitude = 120 - offset * 8;
          return (
            <path
              key={idx}
              d={buildWavePath(baseY, amplitude)}
              fill="none"
              stroke="url(#waveGradient)"
              strokeWidth={2.8 - idx * 0.25}
              className={`wave-path wave-path-${idx + 1}`}
            />
          );
        })}
      </svg>
    </div>
  );
};

export default AnimatedBackground;

